/**
 * Deplace l'element `from` a la position `to`.
 *
 * Isole du composant parce que c'est la seule partie subtile du glisser-
 * deposer : apres le retrait de l'element, les index situes apres lui ont
 * gliss d'un cran, et l'oublier decale la depose d'une position sur deux.
 */
export function reorderIds(
  ids: readonly number[],
  from: number,
  to: number,
): number[] {
  const next = [...ids];
  if (from < 0 || from >= next.length) return next;
  if (to < 0 || to >= next.length) return next;
  if (from === to) return next;
  const [moved] = next.splice(from, 1);
  if (moved === undefined) return [...ids];
  next.splice(to, 0, moved);
  return next;
}

/** Deplace un identifiant d'un cran (`-1` vers le haut, `+1` vers le bas). */
export function moveId(ids: readonly number[], id: number, delta: -1 | 1): number[] {
  const from = ids.indexOf(id);
  if (from === -1) return [...ids];
  return reorderIds(ids, from, from + delta);
}
